import { render, staticRenderFns } from "./SharePrice.vue?vue&type=template&id=0fe5e0c2&scoped=true"
import script from "./SharePrice.vue?vue&type=script&lang=js"
export * from "./SharePrice.vue?vue&type=script&lang=js"
import style0 from "./SharePrice.vue?vue&type=style&index=0&id=0fe5e0c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe5e0c2",
  null
  
)

export default component.exports